import { render } from "./ContextualTitles.vue?vue&type=template&id=bc433250&scoped=true"
import script from "./ContextualTitles.vue?vue&type=script&lang=js"
export * from "./ContextualTitles.vue?vue&type=script&lang=js"

import "./ContextualTitles.vue?vue&type=style&index=0&id=bc433250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc433250"]])

export default __exports__